
import { defineComponent, PropType } from 'vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import { formatTimeStamp } from '@/utils/time'
import { formatTableEmpty } from '@/utils/format'
import { ProcessInfos } from '@/views/dashboard/policy/process-control/process-control.service'

export default defineComponent({
  components: { ContentAdaptLayout, EmptyData },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    processList: {
      type: Array as PropType<ProcessInfos[]>,
      default: []
    },
    policyName: {
      type: String,
      default: ''
    },
  },

  setup (props, context) {
    function handleClose () {
      context.emit('update:modelValue', false)
    }

    return {
      formatTableEmpty,
      formatTimeStamp,
      handleClose,
    }
  }
})
